import { DLDATA_API_ALIAS_VERSION, RSV_CALENDAR_API_ALIAS_VERSION, SKS_MASTER_API_ALIAS_VERSION, SMILE9_API_ALIAS_VERSION } from "./version";

export const environment = {
  name: 'prod',
  production: true,

  // AWS Amplify(Auth)の設定。app.component.tsでロードされる。
  amplify: {
    Auth: {
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_D9wUKUGvo',
      userPoolWebClientId: '31g82bqa96dbmdh6c13prm1uos'
    }
  },
  // API Gatewayのエンドポイントの設定
  apiBaseUrl: 'https://87rds0xmli.execute-api.ap-northeast-1.amazonaws.com/Prod/api',
  // Localstorageの設定
  localstorageBaseKey: 'CognitoIdentityServiceProvider.<31g82bqa96dbmdh6c13prm1uos>.',
  // websiteの設定
  website: 'smile9.astro-rb.com',
  appClientName: 'smile9.astro-rb.com',
};
// ロール
export const ROLES = {
  SYSTEM_ADMIN: 'SystemAdmin',
  ADMIN_USER: 'AdminUser',
  NORMAL_USER: 'NormalUser',
};
export const SERVICE_ROLES = {
  USER: 'User',
  FSC: 'FSC',
  SYSTEM: 'System',
};
export const SMILE9_ROLES = {
  INDIVIDUAL: 'Individual', // 個人
  GUEST: 'GuestUser', // ゲスト利用者
  GENERAL_AFFAIRS: 'GeneralAffairs', // 総務
  FSC: 'FoodCenter', // 給食センター
  ITADAKIMASU: 'ItadakimasuTerm', // いただきます端末
  MENU_DISPLAY: 'CafeMenuTerm', // 食堂メニュー表示端末
  KITCHEN: 'KitchenTerm', // 厨房端末
  SYSTEM: 'SystemAdmin' // システム管理
};
export const GUEST_RESERVATION_AUTH = {
  AUTHORIZED: 'Authorized',
  NO_AUTHORITY: 'NoAuthority'
};
export const HOJO_KBN = {
  ELIGIBLE: 'Eligible',
  NOT_ELIGIBLE: 'NotEligible'
};
// Angularアプリ名
export const THIS_APP_NAME = 'smile9';
// SKSMasterAPI URL
export const SKS_MASTER_API_ENDPOINT = `https://kc6x2irbii.execute-api.ap-northeast-1.amazonaws.com/${SKS_MASTER_API_ALIAS_VERSION}/`;
// smile9 API URL (末尾の"v*-**-**"は対応するAPIGatewayのバージョン(ステージ名)。ダウンタイム無しでアップデートをする際は不具合が起きないよう必要に応じて指定のこと。)
export const SMILE9_API_ENDPOINT = `https://lda82mg876.execute-api.ap-northeast-1.amazonaws.com/${SMILE9_API_ALIAS_VERSION}/`;
// RsvCalendarAPI URL
export const RSV_CALENDAR_API_ENDPOINT = `https://xjdy70ew35.execute-api.ap-northeast-1.amazonaws.com/${RSV_CALENDAR_API_ALIAS_VERSION}/`;
// DlDataAPI URL
export const DLDATA_API_ENDPOINT = `https://8cn9nlwtxa.execute-api.ap-northeast-1.amazonaws.com/${DLDATA_API_ALIAS_VERSION}/`;
export const SMILE9_STATUS_API_ENDPOINT = 'https://8chho8j4a1.execute-api.ap-northeast-1.amazonaws.com/Prod';
export const ERROR_API_ENDPOINT = 'https://9vmk9enw97.execute-api.ap-northeast-1.amazonaws.com/Prod';
export const MAINTENANCE_URL = 'https://smile9-maintenance.astro-rb.com';
// zipcloud API URL
export const ZIPCODE_API_ENDPOINT = 'http://zipcloud.ibsnet.co.jp/api/search';
// ipify URL
export const IPIFY_ENDPOINT = 'https://api.ipify.org/';

export const AWSS3_UP_IMAGES_ENDPOINT = 'https://dzfw71luxd.execute-api.ap-northeast-1.amazonaws.com/Prod/images-uploader/';
export const AWSS3_UP_DOCS_ENDPOINT = 'https://dzfw71luxd.execute-api.ap-northeast-1.amazonaws.com/Prod/doc-uploader/';
export const AWSS3_DL_ENDPOINT = 'https://s3-ap-northeast-1.amazonaws.com/uploads.astro-rb.com/';
export const AWSS3_IMAGES_FOLDER_NAME = 'images';
export const AWSS3_DOCS_FOLDER_NAME = 'doc';
export const KONDATE_IMAGE = {
  MIME_TYPE: 'image/jpeg',
  ALLOW_MIMETYPES: '.jpg, .gif, .png, image/gif, image/jpeg, image/png',
  ALLOW_BYTESIZE: 5000000,
  MAX_WIDTH: 800,
  MIN_HEIGHT: 800,
};
// マニュアル類のURL
export const INDIVIDUAL_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E5%80%8B%E4%BA%BA%E4%BA%88%E7%B4%84.pdf';
export const INDIVIDUAL_MANUAL_URL_INCLUDE_GUEST_INFO = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E5%80%8B%E4%BA%BA%E4%BA%88%E7%B4%84%E3%83%BB%E3%82%B2%E3%82%B9%E3%83%88%E4%BA%88%E7%B4%84.pdf';
export const FSC_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E7%B5%A6%E9%A3%9F%E3%82%BB%E3%83%B3%E3%82%BF%E3%83%BC.pdf';
export const GA_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E7%B7%8F%E5%8B%99%E7%AE%A1%E7%90%86.pdf';
export const ITADAKIMASU_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E3%81%84%E3%81%9F%E3%81%A0%E3%81%8D%E3%81%BE%E3%81%99%E7%AB%AF%E6%9C%AB.pdf';
export const GOCHISOUSAMA_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E3%81%94%E3%81%A1%E3%81%9D%E3%81%86%E3%81%95%E3%81%BE%E7%AB%AF%E6%9C%AB.pdf';
export const SELF_REGI_MANUAL_URL = 'https://smile9.astro-rb.com/manual/smile9%E6%93%8D%E4%BD%9C%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB_%E3%82%BB%E3%83%AB%E3%83%95%E3%83%AC%E3%82%B8%E7%AB%AF%E6%9C%AB.pdf';
export const CAFE_BUSINESS_CALENDAR_MANUAL_URL = 'https://smile9.astro-rb.com/manual/%E9%A3%9F%E5%A0%82%E5%96%B6%E6%A5%AD%E6%97%A5%E3%82%AB%E3%83%AC%E3%83%B3%E3%82%BF%E3%82%99%E3%83%BC%E3%81%AE%E3%81%93%E3%82%99%E6%A1%88%E5%86%85.pdf';
export const EMP_CSV_MANUAL_URL = 'https://smile9.astro-rb.com/manual/%E7%A4%BE%E5%93%A1CSV%E5%8F%96%E8%BE%BC%E4%BB%95%E6%A7%98_ver.1.0.0.xlsx';
export const SKS_WEBSITE = 'https://www.edb.co.jp/';
// XMLHttpRequestのタイムアウト時間
export const XHR_TIMEOUT = 100000;
// Wijmo LicenseKey
export const WIJMO_LICENSEKEY = 'smile9.astro-rb.com,136262862666197#B0swIZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUYRzaBZGTUlDc6kGR734SFVEdsRDcBhjcDJTYS3iTrx6LvMzLIFlU5BVNxNUbWljcvBzSSplaRJXRpdjVvMFeG3UWRlzNNl6RLlmYu54NDF6KwUjdq36R8B7NMRVbkNGTNNUMnhFShZkbrhFVVFlR7Z4dppWNVtyR7QzRidnMxcUQnZFOVJVZw3SZDl5LwA7L4FlaMxkcI3CaUdzT5M7bpBXa7QEZwhkWYdmW7klVzVndRd6LEhDWDpUS9pmWM3mZ98WaVNTVDBnQXpkZipFNyUkSNtSVs3iSI5GWrZ7QEVGWt54Knd5KpZUUGdzTJBFaqZmSkZlbHhzNO9UU9IDaNhFaTlWQlJTd6IXbrh6boNGR6VFeHhHSSdnYFxGM0tiSTVjSPRGWP5WZTBHSJdVVYN4YLFkaaZUbl3iUOplZxsENVd6StBXTr9EO4cnaHdjQzFkYx9kI0IyUiwiIFJTQ7Y4Q9cjI0ICSiwyMwUTO6MjN5cTM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsIyMxQTN8ADI8AjMxAjMwIjI0ICdyNkIsISbvNmLiJXLvJHdzFmL9UGbp56ciojIz5GRiwiI9K88oK88l611kK88xK88l6119K88oK88+S09ayL9Pyb9qCq9iojIh94QiwiI7kTM6YjNyYDOyYjM6MTMiojIklkIs4nIyYHMyAjMiojIMVYd';
// Loading画像表示するか?
export const LOADING_IMAGE = true;
// ページサイズ
export const PAGE_SIZE_ARRAY = [
  {label: 'ページサイズ：全件表示', value: 0, disabled: false},
  {label: 'ページサイズ：5　　　', value: 5, disabled: false},
  {label: 'ページサイズ：10　　　', value: 10, disabled: false},
  {label: 'ページサイズ：30　　　', value: 30, disabled: false},
  {label: 'ページサイズ：50　　　', value: 50, disabled: false},
  {label: 'ページサイズ：100　　　', value: 100, disabled: false},
];
export const PAGE_SIZE_ARRAY_NG = [
  {label: 'ページサイズ：全件表示', value: 9999, disabled: false},
  {label: 'ページサイズ：5　　　', value: 5, disabled: false},
  {label: 'ページサイズ：10　　　', value: 10, disabled: false},
  {label: 'ページサイズ：30　　　', value: 30, disabled: false},
  {label: 'ページサイズ：50　　　', value: 50, disabled: false},
  {label: 'ページサイズ：100　　　', value: 100, disabled: false},
];
// デフォルトページサイズ
export const DEFALUT_PAGE_SIZE = 10;
// selectタグの初期値(必要時に参照のこと)
export const DEFAULT_SELECT_BLANK_VALUE =  { label: '', value: null };
export const DEFAULT_SELECT_BLANK_VALUE_VAL_MINUS =  { label: '', value: -1 };
export const DEFAULT_SELECT_ANY_BLANK_VALUE = function(labelName) { return { label: `${labelName}`, value: null }; };
export const DEFAULT_SELECT_VALUE =  { label: '[選択して下さい]', value: null };
export const DEFAULT_SELECT_VALUE_SM =  { label: '[選択]', value: null };
export const SELECT_ANY_VALUE = function(labelName) { return {label: `[${labelName}を選択して下さい]`, value: null}; };

/** 限定数警告条件(”残りわずか”と表示する条件) */
export const WARN_LIMITED_NUMBER = 10;

export const DAMMY_PASS_FOR_DEMO_USER = '6141';
export const TRUE_PASS_FOR_DEMO_USER = 'Sks00001';

/** 厨房予約実績の自動取得間隔(millisec) */
export const KITCHEN_RSV_RESULT_AUTO_SEARCH_TIME = 30000;

// Slack ログ出力用
export const SLACK_POSTMESSAGE_ENDPOINT = 'https://slack.com/api/chat.postMessage';
export const SLACK_ACCESS_TOKEN = 'xoxb-1245695433093-1475488043653-mJQbpFKzdFUrBnypPgDvsXfG';
export const SLACK_CHANNEL_ERROR_LOGS = 'error-logs-smile9';
